var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { classMap } from 'lit/directives/class-map.js';
import { styleMap } from 'lit/directives/style-map.js';
import { property, state } from "lit/decorators.js";
import { repeat } from 'lit/directives/repeat.js';
import { html, css } from "lit";
import { customElement, PICAction, PICPicker } from '../../Internals';
let PICTimePicker2 = class PICTimePicker2 extends PICPicker {
    set data(data) {
        if (data.hours)
            this.hours = data.hours;
        if (data.minutes)
            this.minutes = data.minutes;
        if (data.parent)
            this.parent = data.parent;
        this.requestUpdate();
    }
    constructor() {
        super();
        this.show = "hidden";
        this.mode_ = '24';
        this.ampm_ = 'AM';
        this.state_ = 'hour';
        this.minArr = ([...Array(60).keys()].map(x => { let t = (++x).toString(); if (t == '60')
            t = '00'; return t; }));
        this.hArr1 = ([...Array(12).keys()].map(x => (++x).toString()));
        this.hArr2 = ([...Array(12).keys()].map(x => { let t = (++x + 12).toString(); if (t == '24')
            t = '00'; return t; }));
        this.hours = 0;
        this.minutes = 0;
    }
    connectedCallback() {
        super.connectedCallback();
        this.cancelAction = new PICAction();
        this.saveAction = new PICAction();
        if (!this.textObj) {
            this.textObj = {
                cancelAction: 'Cancel',
                confirmAction: 'Ok'
            };
        }
    }
    firstUpdated() {
        this.cancelAction.type_ = 'internal';
        this.cancelAction.eventFnc = this.handleCancel.bind(this);
        this.handleClose.bind(this);
        this.saveAction.type_ = 'internal';
        this.saveAction.eventFnc = this.handleSave.bind(this);
    }
    static get styles() {
        const defaultStyle = css `
        :host{
            --pic-timePickerSelectColor: var(--pic-primaryColor);
            --pic-timePickerSelectTextColorDark: var(--pic-onSurfaceHighColor);
            --pic-timePickerSelectTextColorLight: var(--pic-onPrimaryHighColor);
            --pic-timePickerRangeColor: var(--pic-primaryFocusColor);
            --pic-timePickerBackgroundColor: var(--pic-onPrimaryHighColor);
            --pic-timePickerControlsColor: var(--pic-onSurfaceMediumColor);
            --pic-timePickerWeekDayHeaderColor: var(--pic-onSurfaceDisabledColor);
            --pic-scrollbarTrackColor: var(--pic-onPrimaryHighColor);
            --pic-timePickerWeekNoBordercolor: var(--pic-surfaceOverlayDraggedColor);
        }
        .picker.new{
            position: fixed;
            top: var(--pic-tpHeight, 0px)   
        }
        .clock_container{
            height: 324px;
            width: 256px;
            background-color: var(--pic-timePickerBackgroundColor);
            box-shadow: 0px 4px 5px rgba(0, 0, 0, 0.14), 0px 1px 10px rgba(0, 0, 0, 0.12), 0px 2px 4px rgba(0, 0, 0, 0.2);
            padding-left: 7px;
            padding-right: 7px;
            overflow: hidden;
        }
        .header,.footer{
            height: 15%;
            display: flex;
            flex-direction: row;
            align-items: center;
        }
        .header{
            justify-content: center;
        }
        .footer{
            justify-content: space-between;
        }
        .body {
            height: 70%;
        }
        .clockface {
            width: 200px;
            height: 200px;
            background-color: var(--pic-backgroundColor);
            border-radius: 50%;
        }
        .emphasis {
            color: var(--pic-onSurfaceMediumColor);
        }
        .clockCenter{
            background-color: var(--pic-timePickerSelectColor);
            left: calc(50% - 3px);
            top: calc(50% - 3px);
            border-radius: 50%;
            position: absolute;
            height: 6px;
            width: 6px;
            z-index: 2;
        }
        .clockHand{
            height: calc(50% - var(--w));
            width: 2px;
            box-sizing: border-box;
            background-color: var(--pic-timePickerSelectColor);
            top: var(--w);
            left: calc(50% - 1px);
            position: absolute;
            transform-origin: bottom;
            --az: calc(var(--i)*1turn/var(--n));
            transform: rotate(calc(var(--az)));
        }
        .innerRing .item {
            position: absolute;
            top: 50%;
            left: 50%;
            margin: -12px;
            width: 24px;
            height: 24px;
            border-radius: 50%;
            --az: calc(var(--i)*1turn/var(--n));
            transform: rotate(var(--az)) translate(59px) rotate(calc(-1*var(--az)));
            text-align: center;
            line-height: 24px;
            counter-reset: i var(--i);
            z-index: 3;
            cursor: pointer;
        }
        .outerRing .item {
            position: absolute;
            top: 50%;
            left: 50%;
            margin: -14px;
            width: 28px;
            height: 28px;
            border-radius: 50%;
            --az: calc(var(--i)*1turn/var(--n));
            transform: rotate(var(--az)) translate(82px) rotate(calc(-1*var(--az)));
            text-align: center;
            line-height: 28px;
            counter-reset: i var(--i);
            z-index: 3;
            cursor: pointer;
        }
        .item.notvisible{
            background-color: transparent;
            z-index: 1;
        }
        .item.notvisible::before{
            content:'';
        }
        .innerRing h2{
            line-height: 24px;
        }
        .outerRing h2{
            line-height: 28px;
        }
        .clockface h2{
            font-family: 'Montserrat';
            font-style: normal;
            font-weight: normal;
            font-size: 16px;
            line-height: 24px;
            letter-spacing: 0.5px;
            height: inherit;
            text-align: center;

            color: var(--pic-timePickerSelectTextColorDark);

            display: block;
            margin-block-start: unset;
            margin-block-end: unset;
            margin-inline-start: unset;
            margin-inline-end: unset;
            font-weight: unset;
        }
        .clockface h2.selected{
            color: var(--pic-timePickerSelectTextColorLight);
            font-weight: bold;
            z-index: 3;
        }
        .item.selected{
            background: var(--pic-timePickerSelectColor);
            z-index: 2;
        }
        .clickable{
            cursor: pointer;
        }
        `;
        return css `
            ${super.styles}
            ${defaultStyle}
        `;
    }
    handleSave(e) {
        if (this.state_ == 'hour') {
            this.state_ = 'minute';
            this.requestUpdate();
        }
        else {
            let bubblingEvent = { detail: { clickEvent: e, type: 'select', hours: this.hours, minutes: this.minutes }, bubbles: true, composed: true };
            this.dispatchEvent(new CustomEvent('timeselected', bubblingEvent));
            this.handleClose();
        }
    }
    handleCancel(e) {
        let bubblingEvent = { detail: { clickEvent: e, type: 'cancel' }, bubbles: true, composed: true };
        this.dispatchEvent(new CustomEvent('timeselected', bubblingEvent));
        this.handleClose();
    }
    handleClose() {
        this.toggle();
        this.requestUpdate();
    }
    getPickerClass() {
        return {
            picker: true,
            new: true,
            clock_container: true,
            show: this.show == 'show',
            hidden: this.show == 'hidden',
            fade: this.show == 'fade',
            'pic-body2': true
        };
    }
    renderHeader() {
        if (this.mode_ == '24')
            return html `
                <div 
                    class="clickable"
                    @click=${() => { this.state_ = 'hour'; this.requestUpdate(); }}>
                    ${this.hours.toString().padStart(2, '0')}
                </div>
                :
                <div 
                    class="clickable"
                    @click=${() => { this.state_ = 'minute'; this.requestUpdate(); }}>
                    ${this.minutes.toString().padStart(2, '0')}
                </div>
            `;
        else
            return html `
                <div 
                    class="clickable"
                    @click=${() => { this.state_ = 'hour'; this.requestUpdate(); }}>
                    ${this.hours > 12 ? this.hours - 12 : this.hours}
                </div>
                :
                <div 
                    class="clickable"
                    @click=${() => { this.state_ = 'minute'; this.requestUpdate(); }}>
                    ${this.minutes.toString().padStart(2, '0')}
                </div>
                &nbsp;
                <div 
                    class="emphasis clickable"
                    @click=${() => { if (this.ampm_ == 'AM')
                this.ampm_ = 'PM';
            else
                this.ampm_ = 'AM'; }}
                    >
                    ${this.ampm_}
                </div>
            `;
    }
    toggle() {
        super.toggle();
        if (this.show == 'show') {
            this.state_ = 'hour';
        }
    }
    selectItem(e, iVal) {
        if (this.state_ == 'minute')
            this.minutes = parseInt(iVal);
        else {
            this.hours = parseInt(iVal);
            this.state_ = 'minute';
        }
        this.requestUpdate();
    }
    renderOuterRing(iArr) {
        let n = iArr.length; /* how many are ON the circle */
        return html `
            <div style="--n:${n};" class="outerRing">
                ${repeat(iArr, (time) => time, (time, index) => this.renderTime(time, index - (n / 4) + 1))}
            </div>
        `;
    }
    renderClockHand(iArr) {
        return html `
            <div class="clockCenter"></div>
            <div style='--w:${getW(this)};'>
                <div style='--n:${iArr.length};'>
                    <div style='--i:${this.state_ == 'hour' ? this.hours : this.minutes};' class="clockHand">
                    </div>
                </div>
            </div>
        `;
        function getW(tp2Ref) {
            if (tp2Ref.state_ === 'minute')
                return '28px';
            else if (tp2Ref.state_ == 'hour') {
                if (tp2Ref.mode_ == '24' && (tp2Ref.hours > 12 || tp2Ref.hours == 0)) {
                    return '38px';
                }
            }
            return '28px';
        }
    }
    renderInnerRing(iArr) {
        //only render in 24H mode
        if (this.mode_ !== '24')
            return html ``;
        let n = iArr.length;
        return html `
            <div style="--n:${n};" class="innerRing">
                ${repeat(iArr, (time) => time, (time, index) => this.renderTime(time, index - (n / 4) + 1))}
            </div>
        `;
    }
    renderTime(iVal, iIndex) {
        let val = formatVal(iVal, this.state_);
        let isSelected = (this.state_ == 'minute' && parseInt(iVal) == this.minutes) || (this.state_ == 'hour' && parseInt(iVal) == this.hours);
        return html `
            <h2 style="--i:${iIndex};"
                class=${classMap(getItemClass(parseInt(iVal), this, isSelected))}
                data-dispval=${val}
                @click=${(e) => { this.selectItem(e, val); }}>${(parseInt(iVal) % 5 !== 0 && this.state_ == 'minute') ? '' : val}</h2>
            ${isSelected ? getSelectedCircle(iIndex) : ''}
        `;
        function getItemClass(index, tpRef, isSelected) {
            return {
                'item': true,
                'notvisible': (index % 5 !== 0 && tpRef.state_ == 'minute'),
                'selected': isSelected
            };
        }
        function formatVal(iV, curState) {
            if (curState == 'minute') {
                return iV.padStart(2, '0');
            }
            return iV;
        }
        function getSelectedCircle(iIndex) {
            return html `
                <div style="--i:${iIndex};" class="item selected"></div>
            `;
        }
    }
    renderBody() {
        return html `
            <div class="clockface base-center">
                ${this.state_ == 'hour' ?
            html `
                        ${this.renderOuterRing(this.hArr1)}
                        ${this.renderInnerRing(this.hArr2)}
                        ${this.renderClockHand(this.hArr1)}
                    `
            :
                html `
                        ${this.renderOuterRing(this.minArr)}
                        ${this.renderClockHand(this.minArr)}
                    `}
            </div>`;
    }
    renderFooter() {
        return html `
            <pic-button width="105px" etype="text" density="low" .action=${this.cancelAction} label=${this.textObj.cancelAction}></pic-button>
            <pic-button width="70px"  etype="text" density="low" .action=${this.saveAction} label=${this.textObj.confirmAction}></pic-button>
        `;
    }
    isDirectionDown() {
        var _a;
        let isDown = true;
        let parentRect = (_a = this.parent) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
        if (parentRect) {
            let remain = (window.innerHeight - parentRect.bottom);
            if (remain < 324)
                isDown = false;
            else
                isDown = true;
        }
        return isDown;
    }
    getContainerStyle() {
        var _a, _b;
        let styles = [];
        styles.push({ 'position': 'fixed' });
        if (this.isDirectionDown()) {
            styles.push({ 'bottom': 'unset' });
            styles.push({ 'top': ((_a = this.parent) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().bottom) + 5 + 'px' });
        }
        else {
            styles.push({ 'top': 'unset' });
            styles.push({ 'bottom': window.innerHeight - ((_b = this.parent) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect().top) + 'px' });
        }
        return styles.length > 0 ? styles.reduce((total, current) => total = Object.assign(Object.assign({}, total), current)) : {};
    }
    render() {
        //lit sometimes removed px when set inside of html
        // let str = `--pic-tpHeight:${(this.parent?.getBoundingClientRect().bottom??0) + 5}px`;
        // let str1 = `--pic-tpHeight:${(this.parent?.getBoundingClientRect().top??0) - 5}px`;
        // console.log('str', str);
        return html `
            ${this.renderCSS(true)}
            <div 
                class=${classMap(this.getPickerClass())} 
                style=${styleMap(this.getContainerStyle())}
                @click=${(e) => { this.shouldHide = false; }} 
                @animationend=${(e) => { this.handleEnd(e); }}>
                <div class="header pic-h4">
                    ${this.renderHeader()}
                </div>
                <div class="body">
                    ${this.renderBody()}
                </div>
                <div class="footer">
                    ${this.renderFooter()}
                </div>
            </div>
        `;
    }
};
__decorate([
    property()
], PICTimePicker2.prototype, "show", void 0);
__decorate([
    state()
], PICTimePicker2.prototype, "mode_", void 0);
__decorate([
    state()
], PICTimePicker2.prototype, "ampm_", void 0);
__decorate([
    state()
], PICTimePicker2.prototype, "state_", void 0);
PICTimePicker2 = __decorate([
    customElement('pic-timepicker2')
], PICTimePicker2);
export { PICTimePicker2 };
//# sourceMappingURL=PICTimePicker2.js.map